export const REGISTER_FUNNEL = 'REGISTER_FUNNEL';

export const DISMISS_LANGUAGE_SWITCH = 'DISMISS_LANGUAGE_SWITCH';

export const REGISTER_PRO_FUNNEL = 'REGISTER_PRO_FUNNEL';
